export default __webpack_public_path__ + "static/media/adv_contextual_icon.7a094f25.svg";